define("js/specifications-tooltip",["jquery","info-tooltip"],function(i,n){"use strict";return function(o,t){var c=i(t).find(".icon-info");n(c,i("body")),c.on("click",function(i){i.preventDefault()})}});
